// @flow
import React from 'react';
import styled from 'styled-components';
import { colors, fontWeight } from '../constants';
import Tag from './tag';

export const THEMES = {
  visibility: {
    color: colors.darkestYellow,
    backgroundColor: colors.lightYellow,
    borderColor: null,
  },
  alert: {
    color: colors.orange,
    backgroundColor: colors.lightOrange,
    borderColor: null,
  },
  good: {
    color: colors.mediumGreenhouseGreen,
    backgroundColor: colors.lighterGreenhouseGreen,
    borderColor: null,
  },
  terminated: {
    color: colors.white,
    backgroundColor: colors.darkRed,
    borderColor: null,
  },
  responsibility: {
    color: colors.mediumGreenhouseGreen,
    backgroundColor: colors.lighterGreenhouseGreen,
    borderColor: null,
  },
  plain: {
    color: colors.darkestGrey,
    backgroundColor: colors.white,
    borderColor: colors.lightGrey,
  },
};

type Props = {
  theme:
    | 'visibility'
    | 'alert'
    | 'good'
    | 'terminated'
    | 'responsibility'
    | 'plain',
  uppercase: boolean,
  children: React$Node,
};

class Label extends React.Component<Props> {
  static defaultProps = {
    theme: 'visibility',
    uppercase: true,
  };

  getColor() {
    const theme = THEMES[this.props.theme];
    return theme && theme.color;
  }

  getBackgroundColor() {
    const theme = THEMES[this.props.theme];
    return theme && theme.backgroundColor;
  }

  getBorderColor() {
    const theme = THEMES[this.props.theme];
    return theme && theme.borderColor;
  }

  render() {
    const { children, uppercase } = this.props;

    const color = this.getColor();
    const backgroundColor = this.getBackgroundColor();
    const borderColor = this.getBorderColor() || backgroundColor;

    return (
      <LabelWrapper uppercase={uppercase}>
        <Tag
          color={color}
          backgroundColor={backgroundColor}
          borderColor={borderColor}
          fontSize={'11px'}
        >
          {children}
        </Tag>
      </LabelWrapper>
    );
  }
}

/* $FlowFixMe This comment suppresses an error found when upgrading Flow to
 * v0.92.0. To view the error, delete this comment and run Flow. */
const LabelWrapper = styled.span`
  ${fontWeight('heavy')}
  text-transform: ${(props) => (props.uppercase ? 'uppercase' : 'none')};

  span {
    border: 0;
    padding: 4px 7px;
    margin: 0 0 0 3px;
    line-height: 1;
  }

  &:first-child span {
    margin-left: 0;
  }
`;

Label.displayName = 'Label';

export default Label;
